/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Time
 */

module.exports = {

    Clock: require('./Clock'),
    TimerEvent: require('./TimerEvent')

};



//////////////////
// WEBPACK FOOTER
// ./time/index.js
// module id = 971
// module chunks = 0